import { useWatch } from "react-hook-form";
import { AML_COUNTRY_RISK, PI_TYPES, YES_NO_VAL } from "../step3/utils";
import { KYC_SCORE } from "../../../LegalForm/steps/step5/utils";

function useFormInfo({ clientTypeId }) {
  const { privateEnt, privateIndividual, entNaturalPerson } = PI_TYPES;

  const isPrivateInd = clientTypeId === privateIndividual;
  const isPrivateEnt = clientTypeId === privateEnt;
  const isEntNeutral = clientTypeId === entNaturalPerson;

  const isPepValue = useWatch({ name: "isPep" });
  const isPep = Number(isPepValue) === YES_NO_VAL.yes;

  const dualCitizenShipCountryValue = useWatch({
    name: "countryOfCitizenship",
  });
  const isCountryOfHighRiskChosen =
    Number(dualCitizenShipCountryValue?.additionalInfo) === AML_COUNTRY_RISK;

  const economicActivityTypesValue = useWatch({
    name: "economicActivityTypes",
  });

  const hasKycScore = economicActivityTypesValue?.some(
    (item) => item?.kycScore === KYC_SCORE
  );

  return {
    isPrivateInd,
    isPrivateEnt,
    isEntNeutral,
    isPep,
    hasKycScore,
    isCountryOfHighRiskChosen,
    economicActivityTypesValue,
  };
}

export { useFormInfo };
